<tcat-popup #popup [title]="title" [popupType]="popupType" [zIndex]="zIndex" (close)="hide()">
    <div class="row scroll pal mbm">
        <p *ngFor="let message of messages">
            {{message}}
        </p>
    </div>
    <div class="row button-pane pal">
        <button *ngFor="let option of options" class="mrm" (click)="onOptionSelected(option)">{{option.text}}</button>
    </div>
</tcat-popup>